import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { TagWithIdAndName } from '@omnea-app/tags/tagsFrontendClient'
import { TagsHttpClient } from '@omnea-app/tags/tagsHttpClient'

export const GetTagsQueryKey = 'GetTags'

export const useGetTags = (refetchInterval?: number | false) => {
  const { getToken } = useAuthenticatedUser()

  return useQuery<{ tags: TagWithIdAndName[] }, Error>({
    queryKey: [GetTagsQueryKey],
    queryFn: async () => {
      const tagsClient = new TagsHttpClient({ authorization: await getToken() })
      const { data, error } = await tagsClient.GET('/')
      throwIfApiError(error)
      return data
    },
    refetchInterval,
  })
}
